import axios from "@/api/axios";

export async function fetchActiveMenus() {
  const response = await axios.get("/menus");
  return response.data;
}